module.exports = __webpack_public_path__ + "static/media/logo.16e68c87.svg";